/* tslint:disable */

declare var Object: any;
export interface TeodempaddressInterface {
  "empId": string;
  "addresstypeCode": string;
  "address": string;
  "rt"?: string;
  "rw"?: string;
  "subdistrict"?: string;
  "district"?: string;
  "cityId"?: number;
  "stateId"?: number;
  "countryId": number;
  "zipcode"?: string;
  "phone"?: string;
  "livingStatus"?: string;
  "ownerStatus"?: string;
  "addressDistance"?: number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "latLng"?: string;
  "localAddress"?: string;
  rel_address?: any;
}

export class Teodempaddress implements TeodempaddressInterface {
  "empId": string;
  "addresstypeCode": string;
  "address": string;
  "rt": string;
  "rw": string;
  "subdistrict": string;
  "district": string;
  "cityId": number;
  "stateId": number;
  "countryId": number;
  "zipcode": string;
  "phone": string;
  "livingStatus": string;
  "ownerStatus": string;
  "addressDistance": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "latLng": string;
  "localAddress": string;
  rel_address: any;
  constructor(data?: TeodempaddressInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teodempaddress`.
   */
  public static getModelName() {
    return "Teodempaddress";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teodempaddress for dynamic purposes.
  **/
  public static factory(data: TeodempaddressInterface): Teodempaddress{
    return new Teodempaddress(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teodempaddress',
      plural: 'Teodempaddresses',
      path: 'Teodempaddresses',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "addresstypeCode": {
          name: 'addresstypeCode',
          type: 'string'
        },
        "address": {
          name: 'address',
          type: 'string'
        },
        "rt": {
          name: 'rt',
          type: 'string'
        },
        "rw": {
          name: 'rw',
          type: 'string'
        },
        "subdistrict": {
          name: 'subdistrict',
          type: 'string'
        },
        "district": {
          name: 'district',
          type: 'string'
        },
        "cityId": {
          name: 'cityId',
          type: 'number'
        },
        "stateId": {
          name: 'stateId',
          type: 'number'
        },
        "countryId": {
          name: 'countryId',
          type: 'number'
        },
        "zipcode": {
          name: 'zipcode',
          type: 'string'
        },
        "phone": {
          name: 'phone',
          type: 'string'
        },
        "livingStatus": {
          name: 'livingStatus',
          type: 'string'
        },
        "ownerStatus": {
          name: 'ownerStatus',
          type: 'string'
        },
        "addressDistance": {
          name: 'addressDistance',
          type: 'number'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "latLng": {
          name: 'latLng',
          type: 'string'
        },
        "localAddress": {
          name: 'localAddress',
          type: 'string'
        },
      },
      relations: {
        rel_address: {
          name: 'rel_address',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teodempaddress.ts